<div class="layout-topbar">
	<div class="topbar-left">
		<a tabindex="0" class="menu-button" (click)="app.onMenuButtonClick($event)">
			<i class="pi pi-chevron-left"></i>
		</a>
		<span class="topbar-separator"></span>
		<ng-template ngFor let-item let-last="last" [ngForOf]="items">
			<span class="viewname" style="text-transform: uppercase">{{ item.label }}</span>
		</ng-template>
		<img
			id="logo-mobile"
			class="mobile-logo"
			src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/FocusCloud-80x80.png"
			style="width: 30px; height: auto"
			alt="Focus Cloud"
		/>
	</div>

	<div class="topbar-right">
		<ul class="topbar-menu">
			<li class="search-item">
				<p-dropdown
					#topBarVenueSelector
					*ngIf="userService.userVenues.value.length > 0"
					[options]="userService.userVenues.value"
					optionLabel="venueName"
					optionValue="venueKey"
					name="topBarVenueSelector"
					[(ngModel)]="selectedVenueKey"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					filterBy="venueName,venueKey"
					(onChange)="changeVenue(selectedVenueKey, 'topbar.manual')"
				></p-dropdown>
			</li>

			<li>
				<fa-icon
					[icon]="['far', 'cogs']"
					size="2x"
					*ngIf="userService.userSubscription.value?.role >= 6 && venueService.subscriptionVenue.value?.key"
					(click)="venueService.displayVenueTools.next(true)"
				></fa-icon>
			</li>

			<li class="notifications-item" [ngClass]="{ 'active-menuitem ': app.topbarNotificationMenuActive }">
				<a href="#" tabindex="0" (click)="app.onTopbarNotificationMenuButtonClick($event)">
					<i class="pi pi-bell"></i>
					<!-- <span class="topbar-badge">5</span> -->
				</a>
				<ul class="notifications-menu fade-in-up"></ul>
			</li>

			<li class="profile-item" [ngClass]="{ 'active-menuitem fadeInDown': app.topbarUserMenuActive }">
				<a href="#" (click)="app.onTopbarUserMenuButtonClick($event)">
					<!-- <img src="assets/demo/images/avatar/profile.jpg" alt="diamond-layout" class="profile-image"/> -->
					<div class="d-flex flex-column">
						<div class="profile-name" *ngIf="userService.userSubscription.value">
							{{ userService.userSubscription.value?.firstName }} {{ userService.userSubscription.value?.lastName }}
						</div>
						<div class="profile-name" *ngIf="venueService.subscriptionVenue.value.key">
							{{ venueService.subscriptionVenue.value.key }} {{ venueService.subscriptionVenue.value.name }}
						</div>
					</div>
				</a>
				<ul class="profile-menu fade-in-up">
					<li>
						<span (click)="displayProfile = true">
							<i class="pi pi-user"></i>
							<span>Profile</span>
						</span>
					</li>
					<!-- <li>
                        <a href="#">
                            <i class="pi pi-cog"></i>
                            <span>Settings</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i class="pi pi-calendar"></i>
                            <span>Calendar</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i class="pi pi-inbox"></i>
                            <span>Inbox</span>
                        </a>
                    </li> -->
					<li>
						<span (click)="logout()">
							<i class="pi pi-power-off"></i>
							<span>Logout</span>
						</span>
					</li>
				</ul>
			</li>

			<!-- <li class="right-sidebar-item">
                <a href="#" tabindex="0" (click)="app.onRightMenuClick($event)">
                    <i class="pi pi-align-right"></i>
                </a>
            </li> -->
		</ul>
	</div>
</div>

<app-user-detail *ngIf="displayProfile" [(onClose)]="displayProfile"></app-user-detail>
